import { defineStore } from 'pinia'

export const useStatusStore = defineStore('status', {
	state: () => ({
		pending: {
			user: false,
			redirect: false,
		},
		ready: {
			network: false,
			i18n: false,
			absmartly: false,
			coreFeatures: false,
		},
	}),

	getters: {
		resourceIsPending: (state) => (name) => {
			return state.pending[name]
		},

		networkResourceIsReady(state) {
			return state.ready.network
		},

		coreFeaturesResourceIsReady(state) {
			return state.ready.coreFeatures
		},

		requiredResourcesAreReady(state) {
			return ['i18n', 'network', 'absmartly', 'coreFeatures'].every((name) => state.ready[name])
		},

		getResourceIsReady: (state) => (name) => {
			return state.ready[name]
		},
	},

	actions: {
		setResourcePending(name) {
			this.pending[name] = true
		},

		unsetResourcePending(name) {
			this.pending[name] = false
		},

		setResourceReadiness(name) {
			this.ready[name] = true
		},
	},
})
